import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthShell, Field, FormError } from "../components/AuthShell";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [f, setF] = useState({ identifier: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", f);
      setUser(data);
      nav(loc.state?.from || "/dashboard");
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="welcome back" subtitle="log in to your visc.lol" footer={<>no account? <Link to="/register" className="text-[#ff3b91] hover:underline" data-testid="login-register-link">claim a name</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="email or username" data-testid="login-identifier-input" value={f.identifier} onChange={(e) => setF({ ...f, identifier: e.target.value })} required autoComplete="username" />
        <Field label="password" type="password" data-testid="login-password-input" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required autoComplete="current-password" />
        <div className="flex justify-end"><Link to="/forgot-password" className="text-xs text-zinc-500 hover:text-[#ff3b91]" data-testid="login-forgot-link">forgot password?</Link></div>
        <FormError msg={err} />
        <button disabled={busy} className="btn-pink w-full" data-testid="login-submit-button">{busy ? "logging in…" : "log in"}</button>
      </form>
    </AuthShell>
  );
}
